import * as React from "react";
import {Popover} from "@material-ui/core";
import {EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton} from "react-share";
import {EmailIcon, FacebookIcon, LinkedinIcon, TwitterIcon} from "react-share";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {createUrlForCard} from '../utils';

export class SocialMediaPopover extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         modalVisible: false,
         anchorEL: null,
         inputValue: ''
      }
   }
   render() {
      const handlePopover = (e) => {
         this.setState({ 'anchorEL': e.currentTarget, modalVisible: !this.state.modalVisible })
      };
      return (
         <div onClick={(e) => handlePopover(e)}>
            {this.props.button}
            <Popover open={this.state.modalVisible}
               anchorEl={this.state.anchorEL}
               anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
               }}
               transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
               }}
            >
               <div style={{display: 'flex'}}>
                  <TwitterShareButton className="material-button" children={<TwitterIcon size={32} round={true} style={{ margin: '5px' }} />} title={this.props.body} url={this.props.url} />
                  <FacebookShareButton className="material-button" children={<FacebookIcon size={32} round={true} style={{ margin: '5px' }} />} quote={this.props.body} url={this.props.url} />
                  <EmailShareButton className="material-button" children={<EmailIcon size={32} round={true} style={{ margin: '5px' }} />} subject={this.props.subject} body={this.props.body} url={this.props.url} />
                  <LinkedinShareButton className="material-button" children={<LinkedinIcon size={32} round={true} style={{ margin: '5px' }} />} title={this.props.subject} summary={this.props.body} url={this.props.url} />
                  <span
                     style={{
                        border: 0,
                        width: '32px',
                        borderRadius: '30px',
                        height: '32px',
                        margin: '3px',
                        background: '#00a6ac',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px',
                        color: 'white',
                        cursor: 'pointer'
                     }}
                     onClick={async () => {
                        await navigator.clipboard.writeText(this.props.url);
                     }}
                  >
                     <FontAwesomeIcon icon={['far', 'copy']} />
                  </span>
               </div>

            </Popover>
         </div>

      );

   }
}
